import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonComponent } from '@app/shared/button/button.component';
import { ModalSuccessComponent } from '@app/shared/modal-success/modal-success.component';
import { PanelComponent } from '@app/shared/panel/panel.component';
import { RealPropertyLeadService } from '@modules/real-property-lead/services';
import { NgxMaskModule } from 'ngx-mask';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-apply-application',
  templateUrl: './apply-application.component.html',
  styleUrls: ['./apply-application.component.scss'],
  standalone: true,
  imports: [PanelComponent, ButtonComponent, ReactiveFormsModule, ModalSuccessComponent, NgxMaskModule],
})
export class ApplyApplicationComponent implements OnInit, OnDestroy {
  formGroup: FormGroup;
  openPanel = true;
  destroy$: Subject<void> = new Subject<void>();
  isSend = false;
  isSendingApplication = false;
  @Output() visiblePanelChange = new EventEmitter<boolean>();

  constructor(private _realPropertyLeadService: RealPropertyLeadService) {}
  ngOnInit(): void {
    this.formGroup = new FormGroup({
      clientName: new FormControl<string>(null, [Validators.required]),
      clientLogin: new FormControl<string>(null, [Validators.required, Validators.minLength(10), Validators.maxLength(10)]),
    });
  }

  sendApplication() {
    this.isSendingApplication = true;
    this._realPropertyLeadService
      .sendRealPropertyLead(this.formGroup.value)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (typeof data === 'number') {
          this.isSend = true;
        }
        this.isSendingApplication = false;
      });
  }

  visibleChange(event: any) {
    this.visiblePanelChange.emit(event);
  }

  resetForm() {
    this.formGroup.reset();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
